import React from 'react'
import { ActionCreatorWithPayload } from '@reduxjs/toolkit'

import DefineDeviceComponent from 'components/DefineDeviceComponent'

import { HeaderDesktop } from './desktop/HeaderDesktop'
import { HeaderMobile } from './mobile/HeaderMobile'

export const Header: React.FC = () => (
  <DefineDeviceComponent mobileComponent={<HeaderMobile />} desktopComponent={<HeaderDesktop />} />
)
